import { render, staticRenderFns } from "./detailClient.vue?vue&type=template&id=1d83626d"
import script from "./detailClient.vue?vue&type=script&lang=js"
export * from "./detailClient.vue?vue&type=script&lang=js"
import style0 from "./detailClient.vue?vue&type=style&index=0&id=1d83626d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports